




















































import axios from "@/axios";
import { Component, Prop, Vue, Ref, Watch } from "vue-property-decorator";
import Order, { OrderStatus } from "@/models/Order";
import ordersService from "@/services/orders-service";
import restaurantsService from "@/services/restaurants-service";
import OrdersRequestFilter from "@/models/OrdersRequestFilter";
import sumBy from "lodash/sumBy";
import orderBy from "lodash/orderBy"

@Component
export default class Orders extends Vue {
  @Prop()
  status!: OrderStatus[];

  @Watch("$route")
  routeChanged() {
    Vue.nextTick(async () => await this.loadAsync());
  }

  orders: Order[] = [];
  loadOrdersTimer: number = 0;
  played = false
  repeatSound = false;

  orderStatusColor(status: OrderStatus) {
    return Order.orderStatusColor(status);
  }

  orderStatusText(status: OrderStatus) {
    return Order.orderStatusText(status);
  }

  orderSelected(order: Order) {
    console.log(order);
  }

  numItems(order: Order) {
    return sumBy(order.items, i => parseInt(i.amount.toString()));
  }

  async mounted() {
    await this.loadAsync();
    this.loadOrdersTimer = setInterval(async () => {
      await this.loadAsync();
    }, 7000);
    let restaurant = await restaurantsService.findOneAsync(Vue.prototype.$uid);
    if (restaurant && restaurant.continuous_alert) {
      this.repeatSound = true;
    }
    this.played = false;
  }

  playSound() {
    let audio = <HTMLAudioElement>document.getElementById("audio");
    audio.play();
  }

  beforeDestroy() {
    clearInterval(this.loadOrdersTimer);
  }

  async loadAsync() {
    let hasOpenOrders = false
    let newOrders = []
    for (let s of this.status) {
      let items = (await ordersService.findAllAsync(s)).items;
      if (!hasOpenOrders) {
        if (items.filter((i) => i.status == OrderStatus.Pending).length > 0) {
          hasOpenOrders = true
        }
      }
      newOrders.push(...items);
    }
    this.orders = orderBy(newOrders, 'uid', 'desc');
    if (hasOpenOrders && (this.repeatSound || !this.played)) {
      this.playSound();
      this.played = true;
    }
  }
}
